import { memo } from "react";
import { Box } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  [key: string]: any
}

const CustomTabPanel: React.FC<TabPanelProps> = ({
  children,
  index,
  value,
  ...other
}) => {

  const isHidden = value !== index;

  return (
    <div
      role='tabpanel'
      className='tab-panel-content'
      hidden={isHidden}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export default memo(CustomTabPanel);
